import { JobGroupEntityModel } from "src/store/models/entity/jobGroup/entity";
import { JobGroupHelperModel } from "src/store/models/entity/jobGroup/helper";

export const encooJobGroupModels = {
  entity: JobGroupEntityModel,
  helper: JobGroupHelperModel,
};
